import React from 'react';
import classNames from 'clsx';
import { useHistory, useLocation } from 'react-router-dom';

import { isIE11Browser } from 'app/services/util.service';
import { goBackOrHome } from 'app/shared/helpers/goBackOrHome';
import { Modal } from 'app/components/Modal';

import { CompactModalProps } from './CompactModal.interfaces';
import { useStyles } from './CompactModal.styles';

export default function CompactModal(props: CompactModalProps) {
  const {
    children,
    className,
    onClose,
    title,
    withoutHeaderCloseButton,
    uiLiftStyle,
    highZIndex,
    withFooterCloseButton,
    footerCloseButtonTitle,
  } = props;
  const classes = useStyles(props);
  const history = useHistory();
  const location = useLocation();

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }

    const closeRedirect = (location.state as
      | { closeRedirect?: string }
      | undefined)?.closeRedirect;

    if (closeRedirect) {
      history.push(closeRedirect);
      return;
    }

    goBackOrHome(history);
  };

  return (
    <Modal
      opened
      withoutHeaderCloseButton={withoutHeaderCloseButton}
      withFooterCloseButton={withFooterCloseButton}
      footerCloseButtonTitle={footerCloseButtonTitle}
      onClose={handleClose}
      classes={{
        ...(classes.footerCloseButton
          ? { footerCloseButton: classes.footerCloseButton }
          : {}),
        root: classNames(classes.root, className, {
          [classes.rootIE11]: isIE11Browser(),
          [classes.uiLiftRoot]: uiLiftStyle,
        }),
        materialModalRoot: highZIndex
          ? classes.materialModalRootHighZIndex
          : classes.materialModalRoot,
      }}
    >
      {title && <h1 className={classes.title}>{title}</h1>}
      {children}
    </Modal>
  );
}
